import React from "react";
import styled from "styled-components";

const SuccessRoot = styled.div`
  display: grid;
  gap: 0.35rem;

  padding: 0.9rem 1rem;

  border:
    1px solid
    rgba(92, 219, 149, 0.35);

  border-radius: 14px;

  background:
    rgba(92, 219, 149, 0.1);

  color: rgba(247, 247, 247, 0.78);

  ${({ $compact }) => (
    $compact
      ? `
        padding: 0.7rem 0.8rem;
        border-radius: 12px;
      `
      : ""
  )}

  strong {
    color: #8ce5b4;
  }

  b {
    color: #f7f7f7;
  }
`;

export default function AdminSuccessState({
  title,
  message,
  children,
  compact = false,
  ...props
}) {
  return (
    <SuccessRoot
      role="status"
      aria-live="polite"
      aria-atomic="true"
      $compact={compact}
      {...props}
    >
      {title ? (
        <strong>
          {title}
        </strong>
      ) : null}

      {message ? (
        <span>
          {message}
        </span>
      ) : null}

      {children}
    </SuccessRoot>
  );
}
